import { useSignupForm } from "../hooks/useSignupForm";

export function Werkplaats() {
  const { handleSubmit, status, message, isSubmitting } = useSignupForm("werkplaats-waitlist");

  return (
    <section id="werkplaats">
      <div className="container">
        <div className="phase2">
          <div className="phase2-text">
            <div className="eyebrow">Binnenkort</div>
            <h3>Makers Hub Community — een open plek voor makers</h3>
            <p>
              Eén plek waar je binnenstapt, aan je eigen project werkt en leert van wie naast je
              zit. Voor volwassenen vanaf 18 jaar. Geen lessen, geen curriculum —
              gewoon maken, samen.
            </p>
            <div className="phase2-features">
              <div className="phase2-feat">
                <strong>Toegang tot tools</strong>
                <span>Arduino, 3D-printer, soldeerstation — bouw waar je anders geen toegang toe hebt</span>
              </div>
              <div className="phase2-feat">
                <strong>Peer-learning</strong>
                <span>Ervaren members helpen nieuwe. Geen leraren, wél mensen die mee denken</span>
              </div>
              <div className="phase2-feat">
                <strong>Avond &amp; weekend open</strong>
                <span>Buiten school- en werkuren. Drop in wanneer het past</span>
              </div>
              <div className="phase2-feat">
                <strong>Membership vanaf €19/m</strong>
                <span>Student, basic, unlimited of family pass. Drop-in bezoek ook mogelijk</span>
              </div>
            </div>
            <form className="waitlist-form" onSubmit={handleSubmit} noValidate>
              <label className="sr-only" htmlFor="wlName">Naam</label>
              <input type="text" id="wlName" name="name" placeholder="Naam" autoComplete="name" />
              <label className="sr-only" htmlFor="wlEmail">Email</label>
              <input
                type="email"
                id="wlEmail"
                name="email"
                placeholder="jouw@email.be"
                autoComplete="email"
                required
              />
              <button
                type="submit"
                className="btn btn-orange"
                disabled={isSubmitting || status === "ok"}
                aria-busy={isSubmitting}
              >
                {isSubmitting ? "Bezig…" : status === "ok" ? "Verzonden ✓" : "Zet me op de wachtlijst →"}
              </button>
              <div className={`waitlist-msg ${status === "ok" ? "ok" : status === "err" ? "err" : ""}`}>
                {message}
              </div>
              <p className="waitlist-note">
                Geen spam. Eén mailtje zodra de community opent. Uitschrijven met één klik.
              </p>
            </form>
          </div>
          <div className="phase2-img">
            <img src="/assets/sections/werkplaats-space.png" alt="Makers Hub community werkplaats" />
          </div>
        </div>
      </div>
    </section>
  );
}
